package one.healthium.pilates.presentation.navigation.today

import androidx.compose.runtime.Composable
import one.healthium.pilates.ui.workouts.WorkoutsScreen

@Composable
fun TodayContent(
    component: TodayComponent,
) {
    WorkoutsScreen(component)
}